import type { FormField } from '@elfsight/widget-form-builder/widget';
import { useLingui } from '@lingui/react/macro';

export const useInvalidFieldErrorMessageGetter = () => {
  const { t } = useLingui();

  return ({ type, name }: FormField) => {
    if (type === 'phone') {
      return t`Please enter a valid phone number`;
    }

    if (type === 'email') {
      return t`Please enter a valid email`;
    }

    if (type === 'number') {
      return t`Please enter a valid number`;
    }

    if (type === 'URL') {
      return t`Please enter a valid URL`;
    }

    return `Please enter a valid ${name}`;
  };
};
